import Index from './Home';
import Music from './Music';
import Gallery from './Gallery';
import More from './More';

export default { Index, Music, Gallery, More };



// WEBPACK FOOTER //
// ./src/components/index.js